import request from "@/utils/request";

export default function agentGetRFIDCardListByCarIdList(params) {
  return request({
    url: `/user/agent/RFIDCardController/getRFIDCardListByCarIdList`,
    params,
  });
}
